export default function init() {
  const btnYears = document.querySelectorAll(".BlogArchive .side-nav__link")

  btnYears.forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault()
      btn.classList.toggle("active")
    })
  })
}
